const NavBar = () => {
    const scroll=(id="0")=>{
        return document.getElementById(id).scrollIntoView(true);
    }

    return (
        <div className="fade w-full flex flex-row-reverse justify-between items-center fixed top-0 z-10">
            
            <div className="m-6 sm:m-12 text-xs decoration-1 uppercase sm:text-md  font-openSans font-semibold">
                <div className="inline">
                    <a  onClick={()=>scroll('work')}  className="hover:cursor-pointer hover:line-through ">WORK</a>
                    <span className="px-2 ">/</span>
                </div>
                <div className="inline">
                    <a onClick={()=>scroll("about")} className=" hover:cursor-pointer hover:line-through">ABOUT</a>
                    <span className="px-2">/</span>
                </div>
                <div className="inline">
                    <a onClick={()=>scroll("contact")} className=" hover:cursor-pointer hover:line-through">CONTACT</a>
                
                </div>
            </div>

            <div className="hidden sm:block m-6 sm:m-12 text-xs  decoration-1 uppercase sm:text-md  font-openSans font-bold">
                <a href={window.location.href}>Kunal Singh Naruka</a>
            </div>
            {/* <div className="sm:hidden block  m-6 sm:m-12 text-xs  decoration-1 uppercase sm:text-md  font-openSans font-bold">
                <a href={window.location.href}>KSN</a>
            </div> */}
        </div>
    );
};

export default NavBar;